import SVG from 'react-inlinesvg';
import { useTranslation } from 'react-i18next';

import hat from '@/assets/svg/hat.svg';
import logoutIcon from '@/assets/svg/logout.svg';
import UseScreenSize from '@/hooks/UseScreenSize';
import { useAppDispatch } from '@/store';
import userThunks from '@/store/thunks/user';
import { authActions } from '@/store/reducers/auth';
import { appSettingsActions } from '@/store/reducers/settings';

import classNames from './NoLevelAssignedView.module.scss';

/**
 * Shown when a student has no level from any source - no placement-test result, no class
 * default starting level, and no manually assigned level. resolveLevelTestGate returns
 * { route: 'blocked' } for exactly this case rather than silently starting them on level 1.
 *
 * Layout follows the app's existing full-screen blocking-message pattern
 * (DealErrorMessageContent) and the sibling gate screen (LevelTestIntro): centred icon +
 * heading + supporting line, with a sign-out affordance in the corner - this route renders
 * under DashboardLayout, which is only an <Outlet />, so without it the student is stuck
 * here with no way to leave or switch accounts.
 */
const NoLevelAssignedView = () => {
  const { t } = useTranslation();
  const { isMobile } = UseScreenSize();
  const dispatch = useAppDispatch();

  const onSignOut = () => {
    dispatch(userThunks.signOut());
    dispatch(authActions.signOut());
    dispatch(appSettingsActions.clearAppSettings());
  };

  return (
    <div className={classNames.noLevelAssigned}>
      <div className={classNames.signOut}>
        <button onClick={onSignOut}>{isMobile ? <SVG src={logoutIcon} /> : t('exit')}</button>
      </div>
      <SVG className={classNames.icon} src={hat} />
      <h2>{t('noLevelAssignedTitle')}</h2>
      <p>{t('noLevelAssignedMessage')}</p>
    </div>
  );
};

export default NoLevelAssignedView;
